<template>
	<div>
		<ExpensesTabs
			v-if="claimId === 0"
			:tab="'Claims'"
			@tab="onTabChange($event)"			
		/>
		<ProgressGetDataLinear v-if="loading" class="px-5"/>
		<div v-else class="px-6 pb-6">
			<ClaimDetailTitle
				class="head-title my-4 d-print-none" 
				:title="claim_status === draft_status ? `Draft ${claim && claim.number}`:`Submitted ${claim && claim.number}`" 
				:text="`Back`"
				:isClose="claimId !== 0 ? true : false"
				@back="onBack()"
			/>
			<div class="content pt-0 px-1 pb-6">
				<div :class="`${$vuetify.breakpoint.smAndDown? 'content-info-sm' : 'content-info'} py-6`">
					<v-col v-if="submitted_date" :cols="$vuetify.breakpoint.smAndDown ? 12 : 2" md="2" class="pa-1 px-4">
						Submitted Date
						<v-text-field
							:value="formatDate(submitted_date)"
							outlined
							disabled
							dense
							hide-details
							background-color="#FFFFFF"
						>
							<template v-slot:prepend-inner>   
								<Calendar class="mr-1" style="margin-top: 2px" color="rgba(0, 0, 0, 0.38)" width="20" height="20"/>     
							</template>
						</v-text-field>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 2" md="2" class="pa-1  px-4">
						Claim date
						<v-text-field
							v-if="claim_status === approval_status || claim_status === posted_status || !privileges.includes(sec) || claim_status === deleted_status"
							:value="formatDate(claim_date)"
							outlined
							disabled
							dense
							hide-details
							background-color="#FFFFFF"
						>
							<template v-slot:prepend-inner>   
								<Calendar class="mr-1" style="margin-top: 2px" color="rgba(0, 0, 0, 0.38)" width="20" height="20"/>     
							</template>
						</v-text-field>
						<DatePicker
							v-else
							:color="color"
							:background="'#FFFFFF'"
							:lableText="''"
							:isIcon="true"
							:isOutlined="true"
							:dateInit="claim_date_init"
							@date="claim_date = $event"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 2" md="2" class="pa-1  px-4">
						Approval by
						<v-select
							v-model="approval_by"
							:items="app_employees"
							:color="color"
							placeholder="REQUIRED"
							item-text="display_name"
							item-value="id"
							:item-color="color"
							:disabled="claim_status === approval_status || claim_status === posted_status || !privileges.includes(sec) || !privileges.includes('Sceab') || claim_status === deleted_status"
							outlined
							return-object
							hide-details
							dense
							background-color="#FFFFFF"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 2" md="2" class="pa-1  px-4">
						Claim description
						<v-text-field 
							v-model="description" 
							placeholder="REQUIRED"
							:color="color"
							:disabled="claim_status === approval_status || claim_status === posted_status || !privileges.includes(sec) || claim_status === deleted_status"
							hide-details
							outlined
							dense
							background-color="#FFFFFF"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 2" md="2" class="pa-1  px-4">
						Currency
						<v-select
							v-model="currency"
							:items="currencies"
							:color="color"
							item-text="code"
							item-value="id"
							:item-color="color"
							:disabled="claim_status === approval_status || claim_status === posted_status || !privileges.includes(sec) || claim_status === deleted_status"
							return-object
							hide-details
							dense
							outlined
							background-color="#FFFFFF"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 2" md="2" class="pa-1  px-4">
						Amount
						<v-text-field
							:value="`${currency && currency.symbol} ${formatAmount(amount)}`"
							disabled
							outlined
							dense
							hide-details
							background-color="#FFFFFF"
						>
						</v-text-field>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 2" md="2" class="pa-1  px-4">
						<div class="text-default">
							Claim status
						</div>
						<v-text-field
							:value="formatStatus(claim_status)"
							disabled
							outlined
							dense
							hide-details
							background-color="#FFFFFF"
						>
						</v-text-field>
					</v-col>
					<v-col v-if="remark && remark.length !== 0 && claim_status !== approval_status && claim_status !== posted_status" :cols="$vuetify.breakpoint.smAndDown ? 12 : 2" md="2" class="pa-1  px-4">
						<div class="text-default">Comments</div>
						<v-text-field
							:value="remark"
							outlined
							dense
							hide-details
							disabled
							background-color="#FFFFFF"
						>
						</v-text-field>
					</v-col>
					<v-col v-if="claim_status === pending_status" :cols="$vuetify.breakpoint.smAndDown ? 12 : 2" md="2" class="pa-1  px-4">
						<div class="text-default">Claim Period</div>
						<v-text-field
							:value="period ? period.period_desc : ''"
							outlined
							dense
							hide-details
							disabled
							background-color="#FFFFFF"
						>
						</v-text-field>
					</v-col>
				</div>
				<v-alert class="submit-claim-error mx-5" type="error" v-if="error_msg.length !== 0">
					{{ error_msg }}
				</v-alert>
				<div class="my-5 mx-1 px-4">
					Attached Expenses
					<v-btn outlined color="#00AAFD" :disabled="claim_status === approval_status || claim_status === posted_status || !privileges.includes(sec) || claim_status === deleted_status" class="ml-5" @click="onAddReceipts()">
						<v-icon left>mdi-plus</v-icon>
						<span v-if="$vuetify.breakpoint.smAndDown">ADD</span>
						<span v-else>ADD EXPENSE</span>
					</v-btn>
				</div>
				<TableAttachedReceipt 
					class="content-table mt-2 mb-5"
					:color="color" 
					:currencies="currencies"
					:header="header_local"
					:items="filterResults"
					:print="true"
					:isValidation="true"
					:isFile="true"
					:symbol="currency && currency.symbol"
					:gross="formatAmount(valueSum)"
					:tax="formatAmount(taxSum)"
					:amount="formatAmount(toPaySum)"
					:markup="formatAmount(markupSum)"
					@row-click="onRowClick($event)"
					@selected="btnStatus = $event"
				/>
				<v-row class="my-0 mx-3 d-print-none">
					<v-btn outlined color="rgba(8, 14, 20, 0.7)" class="text-capitalize mt-1" :disabled="!(btnStatus && details.length > 0)" @click="onDelReceipts()">
						<DeleteIcon width="20" height="20" class="mr-1 mt-1" :color="btnStatus && details.length > 0 ? 'rgba(8, 14, 20, 0.7)' : 'rgba(0, 0, 0, 0.26)'" />
						<span v-if="$vuetify.breakpoint.smAndDown" style="letter-spacing: 0.5px">Delete</span>
						<span v-else style="letter-spacing: 0.5px">Delete Expenses</span>
					</v-btn>
					<v-btn color="#00AAFD" class="text-capitalize white--text mx-3 mt-1" :disabled="!(isReSubmit && submit_status && details.length > 0)" @click="onReSubmit(pending_status, true)">
						<CircleIcon class="mr-2" v-if="!resubmit_loading" width="20" height="20" :color="isReSubmit && submit_status && details.length > 0? '#FFFFFF':'rgba(0, 0, 0, 0.26)'"/>
						<v-progress-circular v-if="resubmit_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#FFFFFF`" indeterminate></v-progress-circular>
						<span v-if="claim_status === draft_status" style="letter-spacing: 0.5px">Submit</span>
						<span v-if="claim_status !== draft_status">
							<span v-if="$vuetify.breakpoint.smAndDown" style="letter-spacing: 0.5px">Resubmit</span>
							<span v-else style="letter-spacing: 0.5px">Resubmit Claim</span>
						</span>
					</v-btn>
					<v-btn v-if="claim_status === draft_status" class="text-capitalize mr-3 mt-1" outlined color="#00AAFD" :disabled="!(isReSubmit && submit_status && details.length > 0)" @click="onReSubmit(draft_status)">
						<SaveIcon v-if="!redraft_loading" width="20" height="20" :color="isReSubmit && submit_status && details.length >= 1 ? '#00AAFD': 'rgba(0, 0, 0, 0.26)'" class="mr-2"/>
						<v-progress-circular v-if="redraft_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#00AAFD`" indeterminate></v-progress-circular>
						<span v-if="$vuetify.breakpoint.smAndDown" style="letter-spacing: 0.5px">Save</span>
						<span v-else style="letter-spacing: 0.5px">Save and continue later</span>
					</v-btn>
					<v-btn v-if="claimId === 0 && claim_status !== draft_status" class="text-capitalize mr-3 mt-1" outlined color="#00AAFD" @click="onPrint()">
						<Printer v-if="!visible_progress" width="20" height="20" color="#00AAFD" class="mr-2"/>
						<v-progress-circular v-if="visible_progress" class="mr-1" :width="2" :size="16" :value="20" :color="`#00AAFD`" indeterminate></v-progress-circular>
						<span style="letter-spacing: 0.5px">Print Claim</span>
					</v-btn>
					<v-btn class="text-capitalize mt-1" outlined color="#00AAFD" :disabled="claim_status !== deleted_status || !privileges.includes(sec)" @click="onRecoverDialog()">
						<v-icon v-if="!recover_loading" :color="claim_status === deleted_status ? '#00AAFD':'rgba(0, 0, 0, 0.26)'" class="mr-2">mdi-backup-restore</v-icon>
						<v-progress-circular v-if="recover_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
						<span style="letter-spacing: 0.5px">Recover Claim</span>
					</v-btn>
				</v-row>
			</div>
			<LeaveReceiptsDialog
				v-if="unsaved_confirm_visible"
				:visible="unsaved_confirm_visible"
				:type="'warning'"
				:title_text="`You have unsaved claim!`"
				:content_text="`Do you want to save changes before leaving this screen?`"
				:cancel_button="`Cancel`"
				:confirm_button="`Yes, Save`"
				@cancel="onCancelUnsavedConfirm()"
				@ok="onReSubmit(claim_status, true)"
			/>
			<LeaveReceiptsDialog
				v-if="delete_confirm_visible"
				:visible="delete_confirm_visible"
				:type="'warning'"
				:icon="'mdi-alert-circle'"
				:title_text="`Claim has no expenses attached`"
				:content_text="`As this claim has no attached expenses, it will be deleted when you leave this window. Are you sure?`"
				:cancel_button="`Back`"
				:confirm_button="`Delete claim`"
				@cancel="onCancelUnsavedConfirm()"
				@ok="onReSubmit(claim_status)"
			/>
			<RecoverDialog
				v-if="visible_recover"
				:visible="visible_recover"
				:textColor="color"
				:titleText="'Recover deleted claim?'"
				:userName="claim.supplier.display_name"
				@cancel="visible_recover = false"
				@ok="onRecover($event)"
			/>
			<DialogProgress 
				:visible="visible_progress" 
				:color="color"
			/>
			<PrintClaims
				v-if="visible_print"
				id="print"
				style="display: none"
				:printClaims="print_claims"
				:isGST="false"/>
		</div>
	</div>
</template>
<script>
import ClaimDetailTitle from "@/views/expenses/commond/claim_detail_title.vue";
import TableAttachedReceipt from "@/components/table/table_attached_receipt.vue";
import LeaveReceiptsDialog from "@/components/expenses/leave_receipts_dialog";
import DeleteIcon from "@/components/icons/delete_outline";
import CircleIcon from "@/components/icons/submit_circle_outline";
import Printer from "@/components/icons/printer";
import SaveIcon from "@/components/icons/save";
import PrintClaims from '@/components/expenses/print_claims';
import DatePicker from "@/components/date/date_picker.vue";
import DialogProgress from "@/components/dialogs/progress_dialog.vue";
import ExpensesTabs from "@/views/expenses/commond/expenses_tabs";
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import RecoverDialog from "@/views/expenses/commond/recover_dialog.vue";
import Calendar from "@/components/icons/calendar.vue";

import moment from 'moment';
import config from "@/config.js";

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const SCALE = 1.2;
const MAX_WIDTH = 600;
const PAGE_INIT = 0;
const SEC = 'Sec';
const IS_PAID = 1; // 0-not paid or partially paid, 1-completely paid

export default {
	name: 'SubmitClaimsContent',
	props: {
		claimId: {
			type: Number,
			default: 0
		},
		color: {
			type: String,
			default: ""
		},
		currencies: {
			type: Array,
			default: () => [],
		},
		error_message: {
			type: String,
			default: ""
		},
		add_receipts: {
			type: Array,
			default: () => []
		},
		del_receipts: {
			type: Array,
			default: () => []
		},
		update_receipts: {
			type: Array,
			default: () => []
		},
	},
	components: {
		ClaimDetailTitle,
		TableAttachedReceipt,
		LeaveReceiptsDialog,
		DeleteIcon,
		CircleIcon,
		Printer,
		SaveIcon,
		PrintClaims,
		DatePicker,
		DialogProgress,
		ExpensesTabs,
		ProgressGetDataLinear,
		RecoverDialog,
		Calendar
	},
	data() {
		this.sec = SEC;
		this.draft_status = config.claim_statuses.draft.value;
		this.rejected_status = config.claim_statuses.rejected.value;
		this.pending_status = config.claim_statuses.pending.value;
		this.approval_status = config.claim_statuses.approved.value;
		this.posted_status = config.claim_statuses.posted.value;
		this.deleted_status = config.claim_statuses.deleted.value;
		this.remark_date_flag = config.remark_date_flag;

		return {
			loading: false,
			error_msg: this.error_message,
			app_employees: [],

			claim: null,
			submitted_date: '',
			claim_date_init: '',
			claim_date: '',
			approval_by: null,
			description: '',
			currency: { id:0, code:'' },
			amount: '0.00',
			gst_sum: 0,
			to_pay_sum: 0,
			value_sum: 0,
			claim_status: null,
			remark: null,
			remark_origin: null,
			period: null,
			details: [],

			btnStatus: false,
			isReSubmit: false,
			unsaved_confirm_visible: false,
			delete_confirm_visible: false,
			changed_receipts: [],
			tab_tmp: '',

			print_claims: [],
			image_arr: [],
			visible_progress: false,
			visible_print: false,
			visible_recover: false,

			resubmit_loading: false,
			recover_loading: false,
			redraft_loading: false
		}
	},
	created() {
		if (this.$store.state.privileges && this.$store.state.privileges.length === 0) {
			this.initPrivileges();
		} 

		this.load_app_employees();
		this.load_claim();
	},
	watch:{
		error_message() {
			this.error_msg = this.error_message;
		},
		add_receipts() {
			if (this.details.length !== 0) {
				const receipts_ids = this.details.map(detail => {
					return detail.receipt ? detail.receipt.id : detail.id;
				});
				this.add_receipts.forEach(rec => {
					if (!receipts_ids.includes(rec.id)) {
						this.details.push(rec);
					}
				});
			} else {
				this.details = this.add_receipts;
			}
		},
		del_receipts() {
			const arr_tmp = this.details.filter(detail => { 
				const detail_id = detail.receipt ? detail.receipt.id : detail.id;
				return !this.del_receipts.includes(detail_id);
			});

			this.details = arr_tmp;
		},
		update_receipts() {
			if (!this.changed_receipts.includes(this.update_receipts[0].id)) {
				this.changed_receipts.push(this.update_receipts[0].id);
			}

			const arr_tmp = [];
			this.details.forEach(detail => {
				const detail_id = detail.receipt ? detail.receipt.id : detail.id;

				if (detail_id === this.update_receipts[0].id) {
					arr_tmp.push(this.update_receipts[0]);
				} else {
					arr_tmp.push(detail);
				}
			});
      
			this.details = arr_tmp;
		},
		claim_date() {
			this.onReCalculate();
			this.isReSubmit = this._isActive();
		},
		approval_by() {
			this.isReSubmit = this._isActive();
		},
		description() {
			this.isReSubmit = this._isActive();
		},
		currency() {
			this.onReCalculate();
			this.isReSubmit = this._isActive();
		},
		details: {
			handler: function(val, oldVal) { 
				this.onReCalculate();
				if (oldVal.length !== 0) {
					this.isReSubmit = true;
				}
			},
			deep: true
		}
	},
	computed: {
		filterResults() {
			const filterRes = [];
			this.details.forEach(detail => {
				const obj = {};
				const keys = Object.keys(detail);

				if (keys.includes('receipt')) {
					/* from claim's details */
					for (const [key, value] of Object.entries(detail)) {
						if (key === 'job') {
							obj['code'] = value;
							obj['title'] = value;
						} else if (key === 'receipt') {
							obj['currency'] = value.currency;
							obj['date'] = value.date;
							obj['has_tax'] = value.has_tax;
							obj['image'] = value.image;
							obj['image_type'] = value.image_type;
							obj['thumbnail'] = value.thumbnail;
							obj['has_tax'] = value.has_tax;
							obj['value'] = Number(value.gross);
							obj['tax_amount'] = Number(value.tax_amount);
							obj['tax_perc'] = Number(value.tax_perc);
							obj['tax_mode'] = Number(value.taxmode);
							obj['markup_perc'] = Number(Number(value.markup).toFixed(2));
							obj['markup_value'] = Number(value.value);
							obj['amount'] = Number((Number(value.gross) + Number(value.tax_amount)).toFixed(2));
						} else if (key === 'kind') {
							obj[`${key}`] = value;
						} else if (key === 'phase') {
							obj[`${key}`] = value;
						} else if (key === 'description') {
							obj[`${key}`] = value;
						} 
					}

					obj['id'] = detail.receipt.id;
					if (this.claim_status !== this.approval_status && this.claim_status !== this.posted_status && this.claim_status !== this.deleted_status) {
						obj['select'] = false;
					}

				} else {
					/* from original receipt */
					for (const [key, value] of Object.entries(detail)) {
						if (key === 'job') {
							obj['code'] = value;
							obj['title'] = value;
						} else if (key === 'thumbnail') {
							obj[`${key}`] = value;
							obj[`image`] = value;
						} else if (key === 'value') {
							obj['value'] = Number(value);
						} else if (key === 'tax_amount') {
							obj['tax_amount'] = Number(value);
						} else if (key === 'amount') {
							obj['amount'] = Number(value);
						} else if (key === 'markup_perc') {
							obj['markup_perc'] = Number(Number(value).toFixed(2));
						}  else if (key === 'markup_value') {
							obj['markup_value'] = Number(value);
						} else if (key === 'image') {
							obj[`${key}`] = value;
						} else if (key === 'image_type') {
							obj[`${key}`] = value;
						} else if (key === 'has_tax') {
							obj[`${key}`] = value;
						} else if (key === 'tax_mode') {
							obj[`${key}`] = value;
						} else if (key === 'kind') {
							obj[`${key}`] = value;
						} else if (key === 'phase') {
							obj[`${key}`] = value;
						} else if (key === 'description') {
							obj[`${key}`] = value;
						} else if (key === 'employee_id') {
							obj[`${key}`] = value;
						} else if (key === 'currency') {
							obj[`${key}`] = value;
						} else if (key === 'date') {
							obj[`${key}`] = value;
						}
					}
					obj['id'] = detail.id;
					obj['tax_perc'] = detail.tax_perc;
					if (this.claim_status !== this.approval_status && this.claim_status !== this.posted_status && this.claim_status !== this.deleted_status) {
						obj['select'] = false;
					}
				}
				
				filterRes.push(obj);
			});
			
			return filterRes;
		},
		submit_status() {
			let submit_status = true;
			if (this.filterResults.length !== 0) {
				this.filterResults.forEach(res => {
					if (res.value === '0.00') {
						submit_status = false;
					}
					if (!res.kind) {
						submit_status = false;
					}
					if (!res.code) {
						submit_status = false;
					}
					if (!res.title) {
						submit_status = false;
					}
					if (!res.phase) {
						submit_status = false;
					}
				});
			} else {
				submit_status = false;
			}

			if (this.claim_status === this.posted_status || (this.claim && this.claim.is_paid === IS_PAID) || this.claim_status === this.approval_status || this.claim_status === this.deleted_status || !this.privileges.includes(this.sec)) {
				submit_status = false;
			}

			if (!this.approval_by) {
				submit_status = false;
			}

			return submit_status;
		},
		header_local() {
			let header = [];
			
			if(this.claim_status === this.approval_status || this.claim_status === this.posted_status ||this.claim_status === this.deleted_status || !this.privileges.includes(this.sec)) {
				header = config.receipts_head.filter(head => {return head.value !== 'select' && head.value !=='is_used'});
			} else {
				header = config.receipts_head.filter(head => {return head.showable && head.value !=='is_used'});
			}

			return header;
		},
		user_name() {
			let name = '';
			const user = this.$store.state.user;
			if (user) {
				name = user.addressbook.display_name;
			}
			return name;
		},
		user_abid() {
			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			} else {
				return 0;
			}
		},
		privileges() {
			return this.$store.state.privileges.filter(p => { return p.startsWith('S')});
		},
		valueSum() {
			return Number((Number(this.amount) || 0).toFixed(2));
		},
		taxSum() {
			return this.gst_sum;
		},
		toPaySum() {
			return this.to_pay_sum;
		},
		markupSum() {
			return this.value_sum;
		}
	},
	methods:{
		initPrivileges() {
			this.$store.dispatch('update_privileges');
		},
		load_app_employees() {
			const url = "/api/addressbook?abook_types=3&has_privilege=Secap"
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.app_employees = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e;
				})
		},
		load_claim() {
			this.loading = true;
			const id = this.claimId !== 0 ? this.claimId : this.$route.params.id;
			const url = "/api/expenses/claims/" + id;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.claim = data;

						this.submitted_date = this.claim.submitted_date;
						this.claim_date_init = this.claim.date;
						this.claim_date = this.claim.date;
						this.approval_by = this.claim.approval_by;
						this.app_employees = [data.approval_by];
						this.description = this.claim.description;
						this.currency = this.claim.currency;
						this.amount = this.claim.value ? this.claim.value : '0.00';
						this.claim_status = this.claim.status;

						this.remark_origin = this.claim.remark;
						const remark_split_arr = this.claim.remark ? this.claim.remark.split(this.remark_date_flag) : [null, null]; 
						this.remark = remark_split_arr[0] ? remark_split_arr[0] : '';

						this.period = this.claim.period;
						this.details = this.claim.details;

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		formatStatus(claim_status) {
			let status = '';
			if (claim_status === config.claim_statuses.draft.value) {
				status = config.claim_statuses.draft.text
			}
			if (claim_status === config.claim_statuses.pending.value) {
				status = config.claim_statuses.pending.text
			}
			if (claim_status === config.claim_statuses.approved.value) {
				status = config.claim_statuses.approved.text
			}
			if (claim_status === config.claim_statuses.rejected.value) {
				status = config.claim_statuses.rejected.text
			}
			if (claim_status === config.claim_statuses.posted.value && !this.claim.has_payment) {
				status = config.claim_statuses.posted.text
			}
			if (claim_status === config.claim_statuses.posted.value && this.claim.has_payment) {
				status = config.claim_statuses.partiallyPaid.text
			}
			if (claim_status === config.claim_statuses.posted.value && this.claim.is_paid === IS_PAID) {
				status = config.claim_statuses.paid.text
			}
			if (claim_status === config.claim_statuses.deleted.value) {
				status = config.claim_statuses.deleted.text
			}
			return status;
		},
		formatDate(value) {
			if(!value) return null;
			return moment(value).format('DD MMM YYYY');
		},
		formatAmount(value) {
			// from nmber to string, 12345.00 -> 12,345.00
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(Number(value) || 0);
		},
		parseAmount(value) {
			// from string to nmber, 12,345.00 -> 12345.00 
			const amount = Number(String(value).replace(/,/g, ''));

			return Number.isNaN(amount) ? 0 : amount;
		},
		onTabChange(current_tab) {
			if (this.isReSubmit) {
				this.tab_tmp = current_tab;
				if (this.privileges.includes(SEC)) {
					this.unsaved_confirm_visible = true;
				} else {
					if (this.claimId !== 0) {
						this.$emit('close');
					} else {
						if (this.tab_tmp.length !== 0) {
							this.$router.push({ name: this.tab_tmp });
						} else {
							this.$router.push({ name: 'Claims' });
						}
					}
				}
			} else {
				this.$router.push({ name: current_tab });
			}
		},
		onBack() {
			if (this.claimId !== 0) {
				this.$emit('close');
			} else {
				if (this.isReSubmit) {
					if (this.details.length === 0) {
						this.delete_confirm_visible = true;
					} else {
						if (this.privileges.includes(SEC)) {
							this.unsaved_confirm_visible = true;
						} else {
							if (this.claimId !== 0) {
								this.$emit('close');
							} else {
								if (this.tab_tmp.length !== 0) {
									this.$router.push({ name: this.tab_tmp });
								} else {
									this.$router.push({ name: 'Claims' });
								}
							}
						}
					}
				} else {
					this.$router.push({ name: 'Claims' });
				}
			}
		},
		onCancelUnsavedConfirm() {
			if (this.unsaved_confirm_visible) {
				this.unsaved_confirm_visible = false;
			}

			if (this.delete_confirm_visible) {
				this.delete_confirm_visible = false;
			}

			if (this.visible_progress) {
				this.visible_progress = false;
			}

			if (this.visible_print) {
				this.visible_print = false;
			}

			if (this.visible_recover) {
				this.visible_recover = false;
			}

			if (this.claimId !== 0) {
				this.$emit('close');
			} else {
				if (this.tab_tmp.length !== 0) {
					this.$router.push({ name: this.tab_tmp });
				} else {
					this.$router.push({ name: 'Claims' });
				}
			}
		},
		onRowClick(receipt) {
			if (this.claim_status !== this.approval_status && this.claim_status !== this.posted_status && this.privileges.includes(SEC) && this.claim_status !== this.deleted_status) {
				this.$emit('row-click', receipt);
			}
		},
		onAddReceipts() {
			if (this.claim_status !== this.approval_status && this.claim_status !== this.posted_status && this.privileges.includes(SEC) && this.claim_status !== this.deleted_status) {
				const exist_receipt_ids = this.filterResults.map(detail => { return detail.id});
				this.$emit('add-receipts', exist_receipt_ids);
			}
		},
		onDelReceipts() {
			if (!this.btnStatus) return;
			const arr_tmp =  this.filterResults.filter(res => { return !res.select });
			const exist_ids = arr_tmp.map(arr => {return arr.id});

			const details_tmp = this.details.filter(detail => {
				const id = detail.receipt ? detail.receipt.id : detail.id;
				return exist_ids.includes(id)
			});

			this.details = details_tmp;
			this.btnStatus = false;
		},
		async onReSubmit(status, send_email=false) {
			if (this.resubmit_loading || this.redraft_loading) return;
			
			if (status === this.draft_status) {
				this.redraft_loading = true;
			} else {
				this.resubmit_loading = true;
			}

			let is_send_email = false;
			if (send_email && status === this.pending_status) {
				if (this.claim_status === this.draft_status) {
					is_send_email = true;
				}

				if (this.claim_status === this.pending_status) {
					if (this.user_abid !== this.approval_by.id) {
						is_send_email = true;
					}
				}
			}

			if (this.details.length === 0) {
				const claim_obj = {
					supplier_id: this.claim.supplier.id,
					date: this.claim_date,
					desc: this.description,
					currency_id: this.currency.id,
					approval_by: this.approval_by.id,
					status: status,
					remark: this.claim.status !== this.rejected_status ? '' : this.remark_origin,
					period_id: this.period.id,
					send_email: is_send_email,
					details: []
				};

				this._updateClaim(this.claim.id, claim_obj, true);
			}

			if (this.details.length !== 0) {
				const update_receipts = this.filterResults.filter(detail => {
					const receipt_id = detail.id;
					return this.changed_receipts.includes(receipt_id);
				});

				for (let index = 0; index < update_receipts.length; index++) {
					const item = update_receipts[index];
					const receipt_obj = {
						desc: item.description || item.desc || '',
						date: moment(item.date).format("YYYY-MM-DD"),
						currency_id: item.currency.id,
						gross: typeof(item.value) === 'string' ? this.parseAmount(item.value) : Number(item.value.toFixed(2)),
						has_tax: item.has_tax ? 1 : 0,
						job_id: item.code ? item.code.id : item.job.id,
						phase_id: item.phase.id,
						kind_id: item.kind.id,
						tax_mode: item.tax_mode,
						tax_perc: typeof(item.tax_perc) === 'string' ? this.parseAmount(item.tax_perc) : Number(item.tax_perc.toFixed(2)),  
						tax_amount: typeof(item.tax_amount) === 'string' ? this.parseAmount(item.tax_amount) : Number(item.tax_amount.toFixed(2)), 
						markup_perc: typeof(item.markup_perc) === 'string' ? this.parseAmount(item.markup_perc) : Number(item.markup_perc.toFixed(2)), 
						value: typeof(item.markup_value) === 'string' ? this.parseAmount(item.markup_value) : Number(item.markup_value.toFixed(2)), 
					};

					await this._updateReceipt(item.id, receipt_obj);
				}

				if (this.changed_receipts.length === 0) {
					const details = [];
					for (let index = 0; index <  this.filterResults.length; index++) {
						const detail =  this.filterResults[index];

						let gross = detail.value;
						let tax_amount = detail.tax_amount;
						let amount = detail.amount;
						let value_fc = detail.markup_value;

						if (detail.currency.id !== this.currency.id) {
							const rate = Number(await this._get_exchange_rate(this.currency.id, this.claim_date));
							const origin_rate = Number(await this._get_exchange_rate(detail.currency.id, detail.date));

							gross = Number((rate * (gross / origin_rate)).toFixed(2));
							tax_amount = tax_amount === 0 ? 0 : Number((rate * (tax_amount / origin_rate)).toFixed(2));
							amount = amount === 0 ? 0 : Number((rate * (amount / origin_rate)).toFixed(2));
							value_fc = value_fc === 0 ? 0 : Number((rate * (value_fc / origin_rate)).toFixed(2));
						}

						const markup = detail.markup ? detail.markup : detail.markup_perc;
						details.push({
							receipt_id: detail.receipt ? detail.receipt.id : detail.id,
							amount: amount,
							description: detail.description,
							phase_id: detail.phase.id,
							job_id: detail.code ? detail.code.id : detail.job.id,
							kind_id: detail.kind.id,
							gross: gross,
							tax_mode: detail.tax_mode,
							tax_perc: typeof(detail.tax_perc) === 'string' ? this.parseAmount(detail.tax_perc) : Number(detail.tax_perc),
							tax_amount: tax_amount,
							markup: typeof(markup) === 'string' ? this.parseAmount(markup) : Number(markup),
							value_fc: value_fc,
						});
					}

					const claim_obj = {
						supplier_id: this.claim.supplier.id,
						date: this.claim_date,
						desc: this.description,
						currency_id: this.currency.id,
						approval_by: this.approval_by.id,
						status: status,
						remark: this.claim.status !== this.rejected_status ? '' : this.remark_origin,
						period_id: this.period.id,
						send_email: is_send_email,
						details: details
					};

					this._updateClaim(this.claim.id, claim_obj, false);
				}
			}
		},
		async onPrint() {
			this.visible_progress = true;
			this.visible_print = true;
			this.print_claims = [];
			const receipt_with_image  = this.details.filter(d => { return d.receipt.image_type.length !== 0 });

			const image_blob_arr = [];
			for (let index = 0; index < receipt_with_image.length; index++) {
				const detail = receipt_with_image[index];
				const url = `/api/expenses/receipts/${detail.receipt.id}/image`;
				await axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						},
						responseType: 'blob',
					})
					.then((val) => {
						const { status, data } = val;
						if (status === 200) {
							const data_obj = {
								id: this.claim.id,
								data: data
							};
							image_blob_arr.push(data_obj);
						}
					})
					.catch((e) => {
						this.$emit('error-msg', e.message);
					});
			}

			if (image_blob_arr.length === 0) {
				this.setPrintItem();
			} else {
				this.getImageList(image_blob_arr);
			}	
		}, 
		onRecoverDialog() {
			if (this.recover_loading) return;

			if (this.claim_status === this.deleted_status) {
				this.visible_recover = true;
				this.recover_loading = true;
			}
		},
		onRecover(reason) {
			this._recover_claim(this.claim.id, reason);
		},
		getImageList(image_blob_arr) {
			for (let index = 0; index < image_blob_arr.length; index++) {
				const image_blob = image_blob_arr[index];
				if (image_blob.data.type === 'application/pdf') {
					const reader = new FileReader();
					reader.readAsDataURL(image_blob.data);
					reader.onload = readerEvent =>  {
						const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
						loadingTask.promise.then(pdf => {
							const preview_url = [];
							let page_total = pdf.numPages;

							for (let index = 0; index < pdf.numPages; index++) {
								pdf.getPage(index + 1).then(page => {
									const scale = SCALE;
									const viewport = page.getViewport({scale: scale});

									const canvas = document.createElement('canvas');
									const context = canvas.getContext('2d');
									canvas.width = viewport.width;
									canvas.height = viewport.height;

									const renderContext = {
										canvasContext: context,
										viewport: viewport
									};

									const renderTask = page.render(renderContext);
									renderTask.promise.then(() => {
										canvas.toBlob(blob => {
											const preview_item_url = URL.createObjectURL(blob);
											preview_url.push(preview_item_url);
											page_total -= 1;

											if (page_total === PAGE_INIT) {
												const dimension = this.getDimension(viewport.width, viewport.height);
												const image_obj = {
													id: image_blob.id,
													width: dimension.width,
													height: dimension.height,
													image: preview_url
												};
												this.image_arr.push(image_obj);

												if (this.image_arr.length === image_blob_arr.length) {
													this.setPrintItem();
												}
											}
										});									
									});
								});
							}
						});
					};
				} else {
					const my_image = new Image();
					const preview_item_url = URL.createObjectURL(image_blob.data);
					my_image.src = preview_item_url;
					my_image.onload = () => {
						const dimension = this.getDimension(my_image.width, my_image.height);
						const image_obj = {
							id: image_blob.id,
							width: dimension.width,
							height: dimension.height,
							image: preview_item_url
						};
						this.image_arr.push(image_obj);

						if (this.image_arr.length === image_blob_arr.length) {
							this.setPrintItem();
						}
					}
				}				
			}
		},
		getDimension(width, height) {
			let image_width = 0;
			let image_height = 0;

			if (this.$vuetify.breakpoint.smAndDown) {
				/* 48 = padding-left-24px + padding-right-24px */
				if (width > height) {
					image_width = this.$vuetify.breakpoint.width - 48;
					image_height = (this.$vuetify.breakpoint.width - 48) * height / width;
				} else {
					image_height = this.$vuetify.breakpoint.width - 48;
					image_width = (this.$vuetify.breakpoint.width - 48) * width / height;
				}
			} else {
				if (width > height) {
					image_width = MAX_WIDTH;
					image_height = MAX_WIDTH * height / width;
				} else {
					image_height = MAX_WIDTH;
					image_width = MAX_WIDTH * width / height;
				}
			}

			return { width: image_width, height: image_height };
		},
		setPrintItem() {
			const obj = {
				id: this.claim.id,
				number: this.claim.number,
				desc: this.description,
				submitted_date: this.submitted_date,
				value: this.amount,
				currency: this.currency.symbol,
				approval_by: this.approval_by.display_name,
				employee: this.user_name,
				supplier: this.claim.supplier.display_name,
				claim_date: this.claim_date,
				details: this.details,
				image_arr: this.image_arr
			}
			this.print_claims.push(obj);
			this.visible_progress = false;

			setTimeout(() => { 
				const printHtml = document.getElementById("print").innerHTML;
				const printFrame = document.createElement('iframe');
				printFrame.srcdoc = printHtml;
				document.body.appendChild(printFrame);

				printFrame.onload = () => {
					printFrame.contentWindow.print();
					
					const mql = printFrame.contentWindow.matchMedia('print');
					mql.onchange = (e) => {
						if (e.matches) {
							/* before print */
						} else {
							/* after print */
							document.body.removeChild(printFrame);
							this.visible_print = false;
							this.image_arr = [];
						}
					}
				}
			},20);
		},
		async onReCalculate() {
			if (!this.claim_date) return;

			const values = this.filterResults.map(res => {
				return {
					date: res.date,
					currency_id: res.currency.id,
					currency_exrate: res.currency.exrate,
					amount: Number(res.value) || 0,
					gst: Number(res.tax_amount) || 0,
					to_pay: Number(res.amount) || 0,
					value: Number(res.markup_value) || 0
				};
			});

			const requires_exchange = values.some(item => item.currency_id !== this.currency.id);
			const rate = requires_exchange
				? Number(await this._get_exchange_rate(this.currency.id, this.claim_date))
				: 1;

			for (let index = 0; index < values.length; index++) {
				await this.exchange_rate(values[index], rate);
			}

			const sum = key => values.reduce((total, item) => {
				return this._add(total, Number(item[key]) || 0);
			}, 0);

			this.amount = sum('amount').toFixed(2);
			this.gst_sum = Number(sum('gst').toFixed(2));
			this.to_pay_sum = Number(sum('to_pay').toFixed(2));
			this.value_sum = Number(sum('value').toFixed(2));
		},
		async exchange_rate(origin, rate) {
			const exchanged = origin;

			if (origin.currency_id !== this.currency.id) {
				let origin_rate = null;
				if (!origin.currency_exrate) {
					origin_rate = await this._get_exchange_rate(origin.currency_id, origin.date);
				} else {
					origin_rate = origin.currency_exrate;
				}

				const multiplier = Number(rate) / Number(origin_rate);
				['amount', 'gst', 'to_pay', 'value'].forEach(key => {
					exchanged[key] = Number((Number(origin[key]) * multiplier).toFixed(2));
				});
			} 

			return exchanged;
		},
		async _get_exchange_rate(currency_id, date) {
			let rate = null;
			const url = "/api/config/currency/" + currency_id + "/exchange_rates/" + date;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						rate = data.rate;
					} else {
						this.error_msg = reason;
					}					
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
			
			return rate;
		},
		_add(num1, num2) {
			const num1Digits = (num1.toString().split('.')[1] || '').length;
			const num2Digits = (num2.toString().split('.')[1] || '').length;
			const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
			return (num1 * baseNum + num2 * baseNum) / baseNum;
		},
		_isActive() {
			let isReSubmit = false;

			if (this.claim_status === this.draft_status) {
				isReSubmit = true;
			} else {
				if (this.claim_date && this.description.length !== 0) {
					if (this.claim_date !== this.claim.date) {
						isReSubmit = true;
					}
					if (this.description !== this.claim.description) {
						isReSubmit = true;
					}
					if (this.claim.approval_by && this.approval_by && this.approval_by.id !== this.claim.approval_by.id) {
						isReSubmit = true;
					}
					if (this.currency.id !== this.claim.currency.id) {
						isReSubmit = true;
					}
				}
			}

			return isReSubmit;
		},
		async _updateReceipt(id, receipt_obj) {
			const url = "/api/expenses/receipts/" + id;

			await axios
				.put(url, receipt_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;
					if (status == "OK") {
						this.changed_receipts = this.changed_receipts.filter(changed_receipt => {return changed_receipt !== data.id});
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					if (this.resubmit_loading) {
						this.resubmit_loading = false;
					}
					if (this.redraft_loading) {
						this.redraft_loading = false;
					}
				});	
		},
		_updateClaim(id, claim_obj, is_from_delete=false) {
			this.visible_progress = true;

			const url = "/api/expenses/claims/" + id;
			axios
				.put(url, claim_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (is_from_delete) {
							this._deleteClaim(id);
						} else {
							this.visible_progress = false;
							this.isReSubmit = false;
							this.unsaved_confirm_visible = false;
							this.onCancelUnsavedConfirm();
						}
					} else {
						this.visible_progress = false;
						this.error_msg = reason;
					}
				}).catch(e => {
					this.visible_progress = false;
					this.error_msg = e.message;
				})
				.finally(() => {
					if (this.resubmit_loading) {
						this.resubmit_loading = false;
					}
					if (this.redraft_loading) {
						this.redraft_loading = false;
					}
					if(this.visible_progress) {
						this.visible_progress = false;
					}
				});	
		},
		_deleteClaim(id) {
			const url = `/api/expenses/claims/${id}`;

			axios
				.delete(url, {
				}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;
					
					if (status == "OK") {
						this.visible_progress = false;
						this.delete_confirm_visible = false;

						this.onCancelUnsavedConfirm();
					} else {
						this.visible_progress = false;
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.visible_progress = false;
					this.error_msg = e.message;
				})
				.finally(() => {
					if (this.visible_progress) {
						this.visible_progress = false;
					}
				});
		},
		_recover_claim(id, reason) {
			const url = `/api/expenses/claims/${id}/reactivate?remark=${reason}`;

			axios
				.post(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.visible_recover = false;
						this.recover_loading = false;
						this.onCancelUnsavedConfirm();
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.recover_loading = false;
				});
		}
	}
}
</script>
<style lang="scss" scoped>
.claim-container {
	width: 100%;
}
.submit-claim {
  // display: flex;
  // flex-flow: column nowrap;
  // align-items: center;
	padding: 0 24px 24px 24px;
}
.submit-claim-sm {
	padding: 0 ;
}
.submit-claim-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 68px;
  .btn {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 36px;
    color: #00AAFD;
    &:hover {
      cursor: pointer;
    }
    span {
      text-decoration: underline;
    }
  }
	.text {
		font-family: Roboto;
		font-style: normal;
		font-weight: bold;
		font-size: 16px;
		line-height: 24px;
		color: #192A3E;
	}
}
.content {
  background: #FAFAFA;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  // height: calc(100vh - 200px);
}
.content-info {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  width: 100%;
}
.content-info-sm {
  display: flex;
  flex-flow: column nowrap;
	align-items: flex-start;
  width: 100%;
}
.submitted-date-text {
  color: rgba(25, 42, 62, 0.6);
}
.receipts-btn {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	padding: 0 16px;
	height: 70px;
	background: #FAFAFA;
}
.receipts-btn-xs {
	display: flex;
	flex-flow: row;
	justify-content: flex-start;
	align-items: center;
	padding: 0 4px;
	height: 70px;
	background: #FAFAFA;
}
.default-btn {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
	padding: 0 14px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	border-radius: 4px; 
}
.delete-btn-able {
  color: rgba(8, 14, 20, 0.7);
	border: 1px solid rgba(25, 42, 62, 0.7);
  &:hover {
		cursor: pointer;
	}
}
.delete-btn-disable {
  color: rgba(8, 14, 20, 0.4);
	border: 1px solid rgba(25, 42, 62, 0.4);
}
.create-btn-able {
  color: #FFFFFF;
	background: #00AAFD;
  &:hover {
		cursor: pointer;
	}
}
.create-btn-disable {
  color: #FFFFFF;
	background: rgba(8, 14, 20, 0.4);
}
.print-btn-able {
  color: #2196F3;
  border: 1px solid #2196F3;
  &:hover {
		cursor: pointer;
	}
}
.print-btn-disable {
  color: rgba(8, 14, 20, 0.4);
  border: 1px solid rgba(8, 14, 20, 0.4);
}
.text-default {
	color: #192A3E;
}
.text-red {
	color: #F45252;
}
.text-red-text {
	color: #EE0202;
}
.v-tooltip__content {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: white;
	background: #F45252;
	padding: 7px 8px;
}

::v-deep {
	.text-red-text.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea{
		color: #EE0202;
	}
	.text-red-text.v-text-field--outlined fieldset {
		border-color: red;
	}
}
</style>
